// 根据数据来判断状态
export const getState = (data, type = '') => {
  if (type === 'Remittance' || type === 'WorkReport' || type === 'MailRecords') {
    if (data.document_status === -9) {
      return '领导未通过'
    } else if (data.document_status === -2) {
      return '总经理未通过'
    } else if (data.document_status === 0) {
      if (data.manager_review) {
        return '总经理未审批'
      } else {
        return '领导未审批'
      }
    } else if (data.document_status === 2) {
      return '总经理已审批'
    } else if (data.document_status === 9) {
      return '领导已审批'
    }
  } else if (type === 'QuotationApply') {
    if (data.document_status === -9) {
      return '领导未通过'
    } else if (data.document_status === -2) {
      return '总经理未通过'
    } else if (data.document_status === 0) {
      return '未提交审批'
    } else if (data.document_status === 1) {
      return '总经理未审批'
    } else if (data.document_status === 2) {
      return '总经理已审批'
    } else if (data.document_status === 9) {
      return '领导已审批'
    }
  } else if (type === 'ContractManagement') {
    if (data.document_status === 0) {
      return '未提交'
    }
    // 林工、姚总
    if (data.manager_review) {
      if (data.document_status === 1) {
        return '总经理未审批'
      }
      if (data.document_status === 2) {
        return '总经理已审批'
      }
      if (data.document_status === 9) {
        return '领导已审批'
      }
    } else {
      if (data.document_status === 1) {
        return '领导未审批'
      }
      if (data.document_status === 9) {
        return '领导已审批'
      }
    }
  } else {
    // 基本情况
    if (data.document_status === -9) {
      return '领导未通过'
    } else if (data.document_status === -2) {
      return '总经理未通过'
    } else if (data.document_status === -1 || data.document_status === -5) {
      return '财务未通过'
    } else if (data.document_status === 0) {
      if (data.manager_review) {
        return '总经理未审批'
      } else {
        return '财务未审核'
      }
    } else if (data.document_status === 1 || data.document_status === 5) {
      return '财务已审核'
    } else if (data.document_status === 2) {
      return '总经理已审批'
    } else if (data.document_status === 9) {
      return '领导已审批'
    }
  }
}

// 根据数据来判断状态
export const getApprover = (data, type = '') => {
  if (data.document_status <= 0) {
    return '/'
  }

  if (data.document_status === 1 && type === 'QuotationApply') {
    return '/'
  }

  if (type === 'Remittance' || type === 'WorkReport' || type === 'MailRecords' || type === 'QuotationApply') {
    let cacheStrList = []

    if (data.document_status === 2) {
      cacheStrList = ['林源晟']
    } else if (data.document_status === 9) {
      if (data.manager_review) {
        cacheStrList = ['姚杨', '林源晟']
      } else {
        cacheStrList = ['姚杨']
      }
    }

    return cacheStrList.join(', ')
  } else if (type === 'ContractManagement') {
    if (data.document_status === 1) {
      return '/'
    }
    let cacheStrList = []
    if (data.manager_review) {
      if (data.document_status === 2) {
        cacheStrList = ['林源晟']
      } else if (data.document_status === 9) {
        cacheStrList = ['姚杨', '林源晟']
      }
    } else {
      cacheStrList = ['姚杨']
    }

    return cacheStrList.join(', ')
  } else {
    // 带财务的情况
    let cacheStrList = []

    if (data.document_status === 1 || data.document_status === 5) {
      if (data.manager_review) {
        cacheStrList = ['连燕燕', '林源晟']
      } else {
        cacheStrList = ['连燕燕']
      }
    } else if (data.document_status === 2) {
      cacheStrList = ['林源晟']
    } else if (data.document_status === 9) {
      if (data.manager_review) {
        cacheStrList = ['姚杨', '连燕燕', '林源晟']
      } else {
        cacheStrList = ['姚杨', '连燕燕']
      }
    }

    return cacheStrList.join(', ')
  }
}

import store from '../store/index'

/*
  功能: 获取按钮是否可以操作
  数据: data: 数据, menu: 菜单, type: 操作类型
  type: { accept: 通过, revoke: 撤销, refuse: 拒绝 }
*/
export const getApproveBtnVisible = (data, menu, type) => {
  const userName = store.state.userInfo.name
  const authority = String(store.state.userInfo.authority)

  if (type === 'revoke') {
    const flag =
      (data.document_status === 2 && authority.includes('总经理审核')) ||
      (data.document_status === 5 && authority.includes('财务审核')) ||
      (data.document_status === 9 && authority.includes('领导审核') && userName !== '姚力菁')
    return flag ? 'revoke' : ''
  } else {
    if (menu === 'Remittance' || menu === 'WorkReport' || menu === 'MailRecords') {
      // 邮寄、汇款、工作汇报(其它)
      if (type === 'accept' || type === 'refuse') {
        if (data.id > 0 && data.document_status === 0 && data.manager_review && authority.includes('总经理审核')) {
          return 'manager'
        } else if (
          data.id > 0 &&
          ((!data.manager_review && data.document_status === 0) || data.document_status === 2) &&
          authority.includes('领导审核') &&
          userName !== '姚力菁'
        ) {
          return 'leader'
        }
      }
    } else if (menu === 'ContractManagement') {
      if (data.id > 0 && data.document_status === 1 && data.manager_review && authority.includes('总经理审核')) {
        return 'manager'
      } else if (
        data.id > 0 &&
        ((!data.manager_review && data.document_status === 0) || data.document_status === 2) &&
        authority.includes('领导审核')
      ) {
        return 'leader'
      }
    } else if (menu === 'QuotationApply') {
      if (type === 'accept' || type === 'refuse') {
        if (data.id > 0 && data.document_status === 1 && data.manager_review && authority.includes('总经理审核')) {
          return 'manager'
        } else if (
          data.id > 0 &&
          data.document_status === 2 &&
          authority.includes('领导审核') &&
          userName !== '姚力菁'
        ) {
          return 'leader'
        }
      }
    } else {
      // 通用情况(带财务)
      if (type === 'accept' || type === 'refuse') {
        if (data.id > 0 && data.document_status === 0 && data.manager_review && authority.includes('总经理审核')) {
          return 'manager'
        } else if (
          data.id > 0 &&
          ((!data.manager_review && data.document_status === 0) || data.document_status === 2) &&
          authority.includes('财务审核')
        ) {
          return 'financial'
        } else if (data.document_status === 5 && authority.includes('领导审核') && userName !== '姚力菁') {
          return 'leader'
        }
      }
    }
  }

  return ''
}

// 判断数据对于用户是否已完成
export const getSuccessStateByRow = row => {
  const authority = String(store.state.userInfo.authority)

  if (
    (row.document_status >= 2 && authority.includes('总经理审核')) ||
    (row.document_status >= 5 && authority.includes('财务审核')) ||
    (row.document_status >= 9 && authority.includes('领导审核')) ||
    ((!authority || authority === '管理员') && row.document_status >= 9)
  ) {
    return true
  }
  return false
}
